import { render } from "./company.vue?vue&type=template&id=7a851634&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=7a851634&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a851634"

export default script